import { ReactComponent } from "./phone-fill.svg";

interface Props {
  width?: string;
  height?: string;
  fill?: string;
}

const PhoneFillIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default PhoneFillIcon;
